import {
  LayoutDashboard, HardHat, Building2, Truck, CalendarRange, CalendarDays, Gauge, FileText, Bell, Users,
  Settings, User, ClipboardList, Home, FileSpreadsheet, Landmark,
} from "lucide-react";

export const MENUS = {
  admin: [
    ["/", "Dashboard", LayoutDashboard], ["/operai", "Operai", HardHat], ["/cantieri", "Cantieri", Building2],
    ["/mezzi", "Mezzi", Truck], ["/pianificazione", "Pianificazione", CalendarRange], ["/calendario", "Calendario", CalendarDays],
    ["/operativa", "Dashboard Operativa", Gauge], ["/economia", "Economia", Landmark], ["/documenti", "Documenti", FileText], ["/notifiche", "Notifiche", Bell],
    ["/utenti", "Utenti", Users], ["/impostazioni", "Impostazioni", Settings], ["/importa", "Importa da Excel", FileSpreadsheet, "import"],
  ],
  responsabile: [
    ["/", "Dashboard", LayoutDashboard], ["/cantieri", "I miei cantieri", Building2], ["/pianificazione", "Pianificazione", CalendarRange],
    ["/calendario", "Calendario", CalendarDays], ["/operativa", "Dashboard Operativa", Gauge], ["/documenti", "Documenti", FileText],
    ["/notifiche", "Notifiche", Bell],
  ],
  operaio: [
    ["/", "Home", Home], ["/turni", "I miei turni", ClipboardList], ["/calendario", "Calendario", CalendarDays],
    ["/documenti", "Documenti", FileText], ["/notifiche", "Notifiche", Bell], ["/profilo", "Profilo", User],
  ],
};

export const BOTTOM = {
  admin: ["/", "/cantieri", "/pianificazione", "/operativa"],
  responsabile: ["/", "/cantieri", "/pianificazione", "/operativa"],
  operaio: ["/", "/turni", "/calendario", "/notifiche"],
};

export const slug = (p) => (p === "/" ? "dashboard" : p.slice(1));

export const menuFor = (user) => MENUS[user.role].filter(([, , , flag]) => flag !== "import" || user.can_import);
